import { useSearchSuggestionsUpdateRecentSearchesQueries } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsInvalidateRecentSearches";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useEffect } from "react";

/**
 * Whenever user lands on a new search page with a different product search string,
 * we invalidate the recent searches for search suggestions.
 */
export const useSyncRecentSearchesToPageVisit = () => {
  const productSearchString = useSearchPageProductSearchString();

  const addNewRecentSearch =
    useSearchSuggestionsUpdateRecentSearchesQueries("add");

  useEffect(() => {
    addNewRecentSearch(productSearchString);
  }, [addNewRecentSearch, productSearchString]);
};
